var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.renderSrc)?_c('img',{style:(_vm.imageStyle),attrs:{"src":_vm.renderSrc,"alt":_vm.alt,"v-lazy":_vm.isLazyLoad?_vm.renderSrc:''},on:{"error":_vm.handleError}}):_c('svg',{style:({'background-color': _vm.placeholderColor })})}
var staticRenderFns = []

export { render, staticRenderFns }